/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";
import * as Sentry from "@sentry/react";
import { ORGANIZATION_STRUCTURE_FIELDS } from "../../../../contants/formFields";
import { getOptions } from "../../../../utils";
import AutoCompleteDropdown from "../../../common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import Styles from "../style";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import { SET_ORGANISATION_STRUCTURE } from "../../../../redux/actionTypes/meta";
import { OS_REDUX_KEY_MAPPER } from "../../../../contants";
import { isEmptyObj } from "../../../../utils/helper";
import Member from "../../../../services/api/member";

const getMemberOptions = (members) =>
  members.length
    ? members.map((member) => ({
        displayName: `${member.fullName} - ${member.mobileNumber}`,
        value: member.memberId,
      }))
    : [];
const MAX_RESULT = 5;

function MarkLoginOs({
  values,
  errors,
  setFieldValue,
  shouldFetchOtherOS,
  storeValuesInRedux,
  member,
  updateMember,
}) {
  const [districtData, setDistrictData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [memberSearchData, setMemberSearchData] = useState([]);

  const onSearchMember = async (search) => {
    const abortSearch = memberSearchData?.find((m) => m.displayName === search);

    if (abortSearch || !search) return;

    try {
      const formattedQuery = {
        memberId: Number(search),
      };
      const params = {
        pageSize: MAX_RESULT,
      };
      setLoading(true);
      const { data } = await Member.search(formattedQuery, params, false);
      setMemberSearchData(getMemberOptions(data.content));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Sentry.captureException(error);
    }
  };

  const handleInputChange = useCallback(debounce(onSearchMember), [
    member,
    memberSearchData,
  ]);

  const dispatch = useDispatch();
  const formRequestRef = useRef(true);

  const getData = async (api, setState, params, setter) => {
    try {
      let response;
      if (params) {
        response = await api({ data: params });
      } else {
        response = await api({});
      }
      setState(response?.data || response || []);
      if (setter) {
        setter();
      }
      if (storeValuesInRedux) {
        const key = isEmptyObj(params)
          ? "districts"
          : OS_REDUX_KEY_MAPPER[Object.keys(params)[3]];
        dispatch({
          type: SET_ORGANISATION_STRUCTURE,
          payload: {
            [key]: response?.data,
          },
        });
      }
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  const fetchAllOtherOS = () => {
    if (values.districtId) {
      getData(IntroductionFormApi.getAllBlocks, setBlockData, {
        districtId: values.districtId,
      });
    }
  };
  useEffect(() => {
    getData(IntroductionFormApi.getAllDistricts, setDistrictData);
    fetchAllOtherOS();
  }, []);

  useEffect(() => {
    if (shouldFetchOtherOS && formRequestRef.current) {
      fetchAllOtherOS();
      formRequestRef.current = false;
    }
  }, [values, shouldFetchOtherOS]);

  return (
    <div style={Styles.gridContainer}>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Select District"
          name={ORGANIZATION_STRUCTURE_FIELDS.DISTRICT}
          options={getOptions(districtData, "structureId")}
          error={errors[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
          value={values[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
            } else {
              setFieldValue(
                ORGANIZATION_STRUCTURE_FIELDS.DISTRICT,
                selectedValue.value
              );
              getData(IntroductionFormApi.getAllBlocks, setBlockData, {
                districtId: selectedValue.value,
              });
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
              setBlockData([]);
            }
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.blockName}
          label="Select Block"
          name={ORGANIZATION_STRUCTURE_FIELDS.BLOCK}
          options={getOptions(blockData, "structureId")}
          error={errors[ORGANIZATION_STRUCTURE_FIELDS.BLOCK]}
          value={values[ORGANIZATION_STRUCTURE_FIELDS.BLOCK]}
          disabled={!values[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
            } else {
              setFieldValue(
                ORGANIZATION_STRUCTURE_FIELDS.BLOCK,
                selectedValue.value
              );
            }
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.displayName}
          label="Search Member Name/ID"
          name="searchMember"
          options={getOptions(memberSearchData)}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              updateMember({ memberId: "", name: "" }, member.id);
              setMemberSearchData([]);
            }
          }}
          onInputChange={handleInputChange}
          value={values.memberId}
          loading={loading}
          filterSelectedOptions={false}
          filterOptions={(x) => x}
        />
      </div>
    </div>
  );
}

export default MarkLoginOs;
